import type { FC } from 'react';

import { Box, Typography } from '@mui/material';

import { CloseIcon } from '@/icons';

type Props = {
  message?: string;
};

const ModalError: FC<Props> = ({ message }) => {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: 'fit-content',
          flexShrink: 0,
          mb: 1,
          p: '3px',
          color: 'neutral.100',
          bgcolor: 'error.main',
          borderRadius: 100,
        }}
      >
        <CloseIcon sx={{ width: 34, height: 34 }} />
      </Box>
      <Typography
        variant="body1"
        sx={{
          color: 'error.main',
          mb: 1,
          py: 1,
        }}
      >
        {message}
      </Typography>
    </>
  );
};

export default ModalError;
